export const loadTypes = {
  onChangeLoad: 'load/loadMain',
};

export const onChangeLoad = (status) => ({
  type: loadTypes.onChangeLoad,
  payload: status,
});

export default (state = true, action) => {
  switch (action.type) {
    case loadTypes.onChangeLoad: {
      return action.payload;
    }
    default:
      return state;
  }
};
